


















































































































import { faCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { SellerVerification } from '~/models/classified/types'
import UserVerificationChecker from '~/services/user/UserVerificationChecker'
import { format } from '~/utils/date'
import { ciVerifiedBadge } from '~/icons/source/solid/verified-badge'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    seller: { type: Object, required: true },
    widget: { type: Boolean, default: true },
    oneLine: { type: Boolean, default: false }
  },
  computed: {
    icons: () => ({
      check: faCheck,
      info: faInfoCircle,
      verified: ciVerifiedBadge
    }),
    verification(): SellerVerification {
      return this.seller.verification
    },
    onlyPhoneVerified(): boolean {
      const { verification } = this
      return Boolean(
        verification.telephoneVerified && !verification.creditCardVerified
      )
    },
    userSince() {
      return format(this.verification.userSince, 'dd-MM-yyyy', {
        locale: this.$i18n.locale
      })
    },
    userVerificationChecker() {
      return this.$dep(UserVerificationChecker)
    }
  }
})
